// Session-level unlock for the "verify OTP to edit profile" gate.
// Viewing the profile never requires an OTP. The first edit submission in a session
// requires OTP verification; once verified, further edit submissions are allowed for a
// fixed 10-minute window from that verification (no extension on activity -- a new OTP
// is required once that window elapses). Leaving the Profile module for any other
// module clears the unlock immediately, so returning always requires a fresh OTP.

const STORAGE_KEY = "profileEditUnlockedUntil";
export const PROFILE_EDIT_UNLOCK_WINDOW_MS = 10 * 60 * 1000;

export function isProfileEditUnlocked(): boolean {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return false;
  const unlockedUntil = Number(raw);
  return !Number.isNaN(unlockedUntil) && Date.now() < unlockedUntil;
}

export function markProfileEditUnlocked(windowMs: number = PROFILE_EDIT_UNLOCK_WINDOW_MS): void {
  sessionStorage.setItem(STORAGE_KEY, String(Date.now() + windowMs));
}

export function clearProfileEditUnlock(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
